import {
  differenceInMinutes,
  differenceInYears,
  setDate,
  setHours,
  setMinutes,
  setMonth,
  setYear
} from 'date-fns';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';

export const annuallyOn = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences
}: ScheduleSolversDisplayConfigType) => {
  const viewDurationInYears = differenceInYears(endDate, startDate);
  const yearsPassedFromStart = differenceInYears(userDate, startDate);

  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);

  const startDateMonth = startDate.getMonth();
  const startDateDay = startDate.getDate();
  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();

  const startDateInThisYear = setDate(
    setMonth(
      setHours(setMinutes(userDate, startMinutes), startHour),
      startDateMonth
    ),
    startDateDay
  );

  const endDateInThisYear = new Date(
    startDateInThisYear.getTime() + viewDurationInMinutes * 60 * 1000
  );

  if (
    scheduleRepeatEnds === 'onDate' &&
    userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime()
  ) {
    return false;
  }

  if (scheduleRepeatEnds === 'afterOccurrences') {
    const repeatEndYearDate = setYear(
      startDate,
      startDate.getFullYear() + freq * Number(scheduleRepeatEndsOccurrences)
    );

    const repeatEndDate = setDate(
      setMonth(
        setHours(setMinutes(repeatEndYearDate, startMinutes), startHour),
        startDateMonth
      ),
      startDateDay
    );

    if (userDate.getTime() > repeatEndDate.getTime()) {
      return false;
    }
  }

  if (userDate.getTime() < startDate.getTime()) {
    return false;
  }

  return (
    userDate.getTime() >= startDateInThisYear.getTime() &&
    userDate.getTime() <= endDateInThisYear.getTime() &&
    yearsPassedFromStart % freq <= viewDurationInYears
  );
};
